
import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // 页面跳转后滚动到顶部
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <AppRoutes />;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
